import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Modal,
  Backdrop,
  Fade,
  CircularProgress,
} from "@mui/material";
import axios from "axios";

// import { REACT_APP_API_BASE_URL } from "../config";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

// import LanguageSelector from "./product_modal/language_selector";
import MainImage from "./product_modal/main_image";
import ProductName from "./product_modal/product_name";
import ProductType from "./product_modal/product_type";
import OtherImages from "./product_modal/other_images";

import { getAuthHeaders } from "../context/AuthContext";
import ReportFoundButton from "./product_modal/report_found";
import Metadata from "./product_modal/metadata";
import { getApiUrl } from "../utils/apiHelper";
import { useAuth } from "../context/AuthContext";

export default function ProductModal({ open, onClose, image_key, sku, rank, reported, setReported, hideReportFound, client }) {
  const { loginType } = useAuth();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!sku) return;

    const fetchProduct = async () => {
      setLoading(true);
      setProduct(null);

      try {
        const headers = await getAuthHeaders();
        const res = await axios.get(
          getApiUrl(loginType, `/products/${client}/${sku}/`),
          { headers }
        );
        setProduct(res.data);
      } catch (err) {
        setProduct({ error: "Product not found" });
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [sku, client, loginType]);


  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 300 }}
      aria-labelledby="product-modal-title"
      aria-describedby="product-modal-description"
    >
      <Fade in={open}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            maxWidth: 800,
            width: "90vw",
            maxHeight: "80vh",
            overflowY: "auto",
            borderRadius: 2,
          }}
        >
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: (theme) => theme.palette.grey[500],
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>

          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
              <CircularProgress />
            </Box>
          ) : product?.error ? (
            <Typography color="error">{product.error}</Typography>
          ) : (
            <>
              <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                <Typography id="product-modal-title" variant="subtitle1" gutterBottom sx={{fontWeight:600}}>
                  Product Details
                </Typography>
                {!hideReportFound && (
                  <ReportFoundButton  image_key={image_key} sku={sku} rank={rank} reported={reported} setReported={setReported}/>
                )}
              </Box>

              <ProductName product={product}  />

              <ProductType productType={product?.metadata?.product_type} />

              <MainImage mainImage={product?.main_image} />

              <OtherImages otherImages={product?.other_images} />
              <Metadata metadata={product?.metadata} ></Metadata>
            </>
          )}
        </Box>
      </Fade>
    </Modal>
  );
}
